<app-top-nav />
<app-side-nav />
@if (commonUtils.showBanner()) {
  <app-banner
    [drawerOpen]="(this.menuController.isOpen('main-menu') | async) || false"
    (emitExit)="commonUtils.updateBanner(false)"
  />
}
<div class="container">
  <router-outlet />
</div>
